import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

interface SwiperConfig {
  config2: SwiperOptions;
  config3: SwiperOptions;
  config4: SwiperOptions;
  homeBannerConfig: SwiperOptions;
}

export const swiperConfigs: SwiperConfig = {
  config2: {
    autoHeight: true,
    modules: [Navigation, Pagination],
    slidesPerView: 1.15,
    spaceBetween: 8,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 10,
        allowTouchMove: false,
      },
      480: {
        slidesPerView: 1.15,
        spaceBetween: 8,
        allowTouchMove: true,
      }
    }
  },
  config3: {
    autoHeight: true,
    modules: [Navigation, Pagination],
    slidesPerView: 1.15,
    spaceBetween: 8,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      991: {
        slidesPerView: 3,
        spaceBetween: 10,
        allowTouchMove: false,
      },
      767: {
        slidesPerView: 2.3,
        spaceBetween: 10,
        allowTouchMove: true,
      },
      480: {
        slidesPerView: 1.15,
        spaceBetween: 8,
        allowTouchMove: true,
      }
    }
  },
  config4: {
    autoHeight: true,
    modules: [Navigation, Pagination],
    slidesPerView: 1.15,
    spaceBetween: 8,
    slidesPerGroup: 1,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1199: {
        slidesPerView: 4.1,
        spaceBetween: 8,
        slidesPerGroup: 3
      },
      991: {
        slidesPerView: 3.2,
        spaceBetween: 8,
        slidesPerGroup: 3
      },
      767: {
        slidesPerView: 2.15,
        spaceBetween: 10,
        slidesPerGroup: 2
      },
      480: {
        slidesPerView: 1.15,
        spaceBetween: 8,
        slidesPerGroup: 1
      }
    }
  },
  homeBannerConfig: {
    modules: [Navigation, Pagination, Autoplay],
    spaceBetween: 1,
    grabCursor: true,
    slidesPerView: 1.6,
    centeredSlides: true,
    roundLengths: true,
    loop: true,
     autoplay: {
       delay: 10000, // 10 seconds
       disableOnInteraction: false, // Continue autoplay after user interaction
       pauseOnMouseEnter: true, // Pause on hover
     },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 1.6
      },
      480: {
        slidesPerView: 1.3
      }
    }
  }
};
